import { useCIMSTableContext } from '../../../../..'
import { WithRecord } from '../../../../../../types'
import DisablableRowActionButton from './DisablableRowActionButton'

function RestoreRowActionButton<T extends object>({ record }: WithRecord<T>) {
  const { actions } = useCIMSTableContext<T>()
  const { onRestore, disabled } = actions.row?.restore ?? {}
  return (
    <DisablableRowActionButton
      record={record}
      disabled={disabled}
      callback={onRestore}
    >
      Restore
    </DisablableRowActionButton>
  )
}

export default RestoreRowActionButton
